import { BusinessAccessLevelEnum } from '@/services/types/Account';
import { EnumValues } from '@/services/types/EnumValues';
import { AccountType, AccountTypeEnum } from '@/context/types/Account';

type TAccessLevel = EnumValues<typeof BusinessAccessLevelEnum>;

/**
 * Batch payments (the Move Money menu item, the new-batch route, and the batch-groups data
 * source inside Manage Payment) are restricted to Business/Sole Trader/Organisation Owner or
 * Admin profiles — never Personal profiles, and never a business Team Member. The backend never
 * surfaces a distinct accountType for Sole Trader/Organisation (they're all `business` with a
 * nested `businessType`), so `accountType === BUSINESS` already covers all three.
 */
export const canAccessBatchPayments = (
  accountType: AccountType | undefined,
  accessLevel: TAccessLevel | undefined
): boolean =>
  accountType === AccountTypeEnum.BUSINESS &&
  (accessLevel === BusinessAccessLevelEnum.OWNER || accessLevel === BusinessAccessLevelEnum.ADMIN);
